import { computed, effectScope, type ComputedRef } from 'vue'
import { useNode } from './store'
import { ticksFor } from './util'

// Tick positions for the current window, shared by the axis and every bar so
// they always line up: one computed for the whole app (it was one per bar,
// each redone every second), in a scope of its own so it outlives the first
// bar that asked for it.
let shared: ComputedRef<ReturnType<typeof ticksFor>> | undefined
export function useTicks() {
    const node = useNode()
    shared ??= effectScope(true).run(() => computed(() => ticksFor(node.span[0], node.span[1])))!
    return shared
}
